import * as React from 'react';
import styled, { cx } from 'react-emotion';
import { styles } from './styles';
import Textarea from 'react-textarea-autosize';
import { Label } from '../Label';

interface BaseProps {
  error?: boolean;
  disabled?: boolean;
  disableBorder?: boolean;
  inGroup?: boolean;
  groupFirst?: boolean;
  groupLast?: boolean;
}

type LabelPosition = 'left' | 'right';

interface InputAction {
  action: string | JSX.Element | object | undefined;
  actionPosition: LabelPosition;
}

interface InputLabel {
  label: string | JSX.Element | object | undefined;
  labelPosition: LabelPosition;
}

type InputProps = BaseProps & InputLabel & InputAction & React.InputHTMLAttributes<any>;

export const InputComponent = styled<'input'>('input')<BaseProps>(
  ({ error, disabled, inGroup, groupFirst, groupLast, disableBorder }) => {
    return styles.input(error, disabled, inGroup, groupFirst, groupLast, false, disableBorder);
  }
);

export const TextAreaComponent = styled<'input'>('input')<BaseProps>(
  ({ error, disabled, inGroup, groupFirst, groupLast }) => {
    return styles.input(error, disabled, inGroup, groupFirst, groupLast, true);
  }
).withComponent('textarea');

export class Input extends React.Component<InputProps> {
  static defaultProps: Pick<InputProps, keyof InputLabel | keyof InputAction> = {
    label: '',
    labelPosition: 'right',
    action: undefined,
    actionPosition: 'right'
  };

  render() {
    const { label, labelPosition, action, actionPosition, inGroup, className } = this.props;
    // TODO: implement a scalable solution for different action/label types
    const labelElement = !!label && Label.create({ children: label });
    const actionElement = !!action && action;
    return (
      <>
        <div className={cx(styles.inputContainer(inGroup), className)}>
          {actionPosition === 'left' && actionElement}
          {labelPosition === 'left' && labelElement}
          <InputComponent {...this.props} />
          {labelPosition === 'right' && labelElement}
          {actionPosition === 'right' && actionElement}
        </div>
        {this.props.inGroup && !this.props.groupLast ? <span className={styles.groupBreak} /> : null}
      </>
    );
  }
}

// export const Input: React.SFC<Props & Label & React.InputHTMLAttributes<any>> = props => (
//   <>
//     <div><InputComponent {...props} /></div>
//     {props.inGroup && !props.groupLast ? <span className={styles.groupBreak} /> : null}
//   </>
// );

export const TextArea: React.SFC<BaseProps & React.TextareaHTMLAttributes<any>> = props => (
  <>
    <Textarea {...props} className={styles.textarea(props.error, props.disabled)} value={props.value as any} />
    {props.inGroup && !props.groupLast ? <span className={styles.groupBreak} /> : null}
  </>
);
